import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/constitution/proposals')({

}).lazy(() => import('./proposals.lazy').then((d) => d.Route));
